import { assign, groupBy, partial, sortBy } from 'lodash-es';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { downloadAssets } from '../../../actionCreators/downloadAssets';
import ElementAssets from '../../../components/handoff/sidebar/ElementAssets';
import onlyIf from '../../../hocs/onlyIf';
import * as assetDownloadSelectors from '../../../selectors/downloadAssets';
import { getCurrentScreen } from '../../../selectors/screen';
import { getBestAsset } from '../../../utils/handoff/assets';
import * as elementUtils from '../../../utils/handoff/element';
var ASSET_WIDTH = 54;
function mapStateToProps(state, _a) {
    var element = _a.element;
    var currentScreen = getCurrentScreen(state);
    var assets = elementUtils.getAssets(element);
    if (!assets.length) {
        return {};
    }
    var assetsGroupedByType = groupBy(sortBy(assets, 'format'), 'format');
    return {
        assetWidth: ASSET_WIDTH,
        assets: assetsGroupedByType,
        bestAssetUrl: getBestAsset(assetsGroupedByType, ASSET_WIDTH),
        elementID: element.id,
        hasDownloaded: partial(assetDownloadSelectors.hasDownloaded, state),
        isDownloading: partial(assetDownloadSelectors.isDownloading, state),
        name: elementUtils.getLayerName(element),
        screenID: currentScreen.id,
    };
}
function mergeProps(stateProps, _a, ownProps) {
    var dispatch = _a.dispatch;
    var screenID = stateProps.screenID, elementID = stateProps.elementID, isDownloading = stateProps.isDownloading, hasDownloaded = stateProps.hasDownloaded;
    var newProps = {
        downloadType: function (assetType) {
            dispatch(downloadAssets({ screenID: screenID, elementID: elementID, assetType: assetType }));
        },
        downloadAll: function () {
            dispatch(downloadAssets({ screenID: screenID, elementID: elementID }));
        },
        isDownloadingType: function (assetType) {
            return isDownloading({ screenID: screenID, elementID: elementID, assetType: assetType });
        },
        hasDownloadedType: function (assetType) {
            return hasDownloaded({ screenID: screenID, elementID: elementID, assetType: assetType });
        },
        isDownloadingAll: function () {
            return isDownloading({ screenID: screenID, elementID: elementID });
        },
        hasDownloadedAll: function () {
            return hasDownloaded({ screenID: screenID, elementID: elementID });
        },
    };
    return assign({}, ownProps, stateProps, newProps);
}
export default compose(connect(mapStateToProps, null, mergeProps), onlyIf(function (props) { return props.assets; }))(ElementAssets);
